<script>
import { defineComponent, h } from "vue";
export default defineComponent({
  name: "DocumentDrivenNotFound",
  render() {
    return h("div", "Document not found");
  }
});
</script>
